<template>
  <div>
    <div class="flex align-center between">
      <b>{{ inputkey }}</b>
      <code>[{{ input.type }}]</code>
      <span class="flex around align-center">
        <i
          @click="$set(show, 'newfunctiontest' + inputkey, 'function')"
          class="fas fa-function m4"
        ></i>
        <i
          @click="$set(show, 'newfunctiontest' + inputkey, 'state')"
          class="fa fa-object-group m4"
        ></i>
        <i
          @click="$set(show, 'newfunctiontest' + inputkey, 'manual')"
          class="fa fa-edit m4"
        ></i>
      </span>
    </div>
    <iinput v-if="input.value !== 'static'" v-model="test[inputkey]" />
    <!-- <input
      v-if="
        show['newfunctiontest' + inputkey] === 'manual' &&
        (input.type === 'number' || input.type === 'string')
      "
      class="xs-input"
      :type="input.type === 'number' ? 'number' : 'text'"
      v-model="test[inputkey]"
      :placeholder="inputkey + ' [' + input.type + ']'"
    />
    <textarea
      v-if="
        show['newfunctiontest' + inputkey] === 'manual' &&
        !(input.type === 'number' || input.type === 'string')
      "
      class="xs-font"
      :type="input.type === 'number' ? 'number' : 'text'"
      v-model="test[inputkey]"
      :placeholder="inputkey + ' [' + input.type + ']'"
    ></textarea>
    <div
      class="flex between"
      v-if="show['newfunctiontest' + inputkey] === 'state'"
    >
      <state
        parent="state"
        :statedata="$store.state"
        :select="'testfn' + inputkey"
      />
      <div class="flexy">
        <button
          :disabled="
            !$store.state.select['testfn' + inputkey]
          "
          :key="$store.state.counter + 'testfn' + inputkey"
          type="button"
          @click="
            $set(test, inputkey, $store.state.select['testfn' + inputkey].val);
            $set($store.state.select, 'testfn' + inputkey, false);
            $set(show, 'newfunctiontest', false);
          "
          class="success xs-font p4"
        >Set Value </button>
        <div class="container p4" style="max-height: 48px; overflow: scroll">
          <code class="xs-font">{{
            $store.state.select["testfn" + inputkey] &&
            $store.state.select["testfn" + inputkey].val
          }}</code>
        </div>
      </div>
    </div>
    <select
      v-model="test[inputkey]"
      v-if="show['newfunctiontest' + inputkey] === 'function'"
    >
      <option
        v-for="(fn, fnkey) in $store.state.app.advanced.functions"
        :value="fnkey"
        :key="fnkey"
      >
        {{ fnkey }}
      </option>
    </select> -->
    <div v-if="show['newfunctiontest' + inputkey] === 'function'">{{$store.state.app.advanced.functions[test[inputkey]]}}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: {},
    };
  },
  props: {
    input: { type: Object },
    inputkey: { type: String },
    test: { type: Object },
  },
  mounted () {
    this.input.value == 'static' ? this.test[this.inputkey] = this.input.static : null;
  },
};
</script>